import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { ApiResponse } from '../../data/system/allotment';
import { RealignmentData } from '../../data/system/realignment';

@Injectable()
export class RealignmentService extends RealignmentData {

  constructor(private http: HttpClient) { super(); }

  save(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_save}`;
    return this.http.post<ApiResponse>(host, params);
  }

  saveAttachment(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_save_attachment}`;
    return this.http.post<ApiResponse>(host, params);
  }

  get(year: string | number, code: string, campus: any, page: any, page_size: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_get}`;
    return this.http.post<ApiResponse>(host, { year: year, code: code, campus: campus, page: page, page_size: page_size });
  }

  delete(id: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_delete}`;
    return this.http.post<ApiResponse>(host, { id: id });
  }

  deleteAttachment(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_delete_attachment}`;
    return this.http.delete<ApiResponse>(host, { params });
  }

  deleteDetails(id: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_details_delete}`;
    return this.http.post<ApiResponse>(host, { id: id });
  }

  update(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_udpate}`;
    return this.http.post<ApiResponse>(host, params);
  }

  changeStatus(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_change_status}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getSignatories(campus_id: number | string): Observable<any> {
    const host = `${env.host}${env.endpoint.realignment_signatories}`;
    return this.http.post<any>(host, { campus: campus_id });
  }

  getSignature(emp_code: number | string): Observable<any> {
    const host = `${env.host}${env.endpoint.realignment_signature.replace(':emp_code', emp_code)}`;
    return this.http.get<any>(host);
  }

  getForSignDocuments(emp_code: number | string): Observable<any> {
    const host = `${env.host}${env.endpoint.realignment_for_sign.replace(':emp_code', emp_code)}`;
    return this.http.get<any>(host);
  }

  getApprovedDocuments(emp_code: number | string): Observable<any> {
    const host = `${env.host}${env.endpoint.realignment_approved_documents.replace(':emp_code', emp_code)}`;
    return this.http.get<any>(host);
  }

  nextSeries(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.realignment_next_series}`;
    return this.http.post<ApiResponse>(host, params);
  }

}
